<template>
    <b-card no-body >
        <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-1 variant="info">
                <b-icon icon="search" aria-hidden="true"></b-icon>
                Filtro de busqueda
            </b-button>
        </b-card-header>
        <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
            <b-card-body>
                <b-card-text>
                    <b-row>        
                        <b-col cols="12" md="4">
                            <label for="codigoItem">Código Item</label>
                            <b-form-input id="codigoItem" v-model="filter.codigoItem" @keydown.enter.prevent="$emit('get-items-list-empresa')" placeholder="Código Item"></b-form-input>
                        </b-col>                    
                        <b-col cols="12" md="4">
                            <label for="nombre">Nombre</label>
                            <b-form-input id="nombre" v-model="filter.nombre" @keydown.enter.prevent="$emit('get-items-list-empresa')" placeholder="Nombre"></b-form-input>
                        </b-col>
                        <b-col cols="12" md="4">
                            <label for="categoria">Categoría</label>
                                <b-form-group>
                                    
                                <b-form-select
                                v-model="filter.categoryId"
                                :options="categoriesList"
                                id="categoria"
                                class="mb-3"
                                value-field="id"
                                text-field="nombre"
                                >
                                <template #first>
                                    <b-form-select-option value="">SELECCIONE</b-form-select-option>
                                </template>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="12">
                            <div >
                                <b-button variant="info" @click.prevent="$emit('get-items-list-empresa')" class="mx-1">
                                    <b-icon icon="search" aria-hidden="true"></b-icon>
                                    Buscar
                                </b-button>
                                <b-button variant="warning" @click.prevent="$emit('clear-filter-form')" class="mx-1 text-white">
                                    <b-icon icon="backspace" aria-hidden="true"></b-icon>
                                    Limpiar
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-card-text>
            </b-card-body>
        </b-collapse>
    </b-card>
    
</template>

<script>
export default {
    name: "FilterForm",
    props: {
        filter: {
            type: Object
        },
        categoriesList: {
            type: Array
        }
    }
};

</script>
<style scoped>

</style>